import { render, staticRenderFns } from "./BillboardCreate.vue?vue&type=template&id=60844e77&scoped=true&"
import script from "./BillboardCreate.vue?vue&type=script&lang=ts&"
export * from "./BillboardCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60844e77",
  null
  
)

export default component.exports